import React, { useEffect, useState } from "react";
import { Clock, AlarmClock } from "lucide-react";

// Live countdown to the moment an unaccepted order is auto-cancelled.
export default function AutoRejectCountdown({ deadline, className = "" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  if (!deadline) return null;
  const ms = new Date(deadline).getTime() - now;
  const secs = Math.max(0, Math.floor(ms / 1000));
  const mm = String(Math.floor(secs / 60)).padStart(2, "0");
  const ss = String(secs % 60).padStart(2, "0");
  const urgent = secs <= 60;
  const Icon = urgent ? AlarmClock : Clock;
  return (
    <span
      data-testid="auto-reject-countdown"
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-bold tabular-nums ${urgent ? "bg-red-100 text-red-700" : "bg-amber-100 text-amber-700"} ${className}`}
      title="Accept before this order is auto-cancelled"
    >
      <Icon className="h-3.5 w-3.5" />
      {secs === 0 ? "Auto-cancelling…" : `Auto-cancels in ${mm}:${ss}`}
    </span>
  );
}
